module.exports = __webpack_public_path__ + "img/game-on.ffb8f522.svg";